import { useState } from 'react';
import {
  Button,
  ButtonTier,
  Card,
  CardContent,
  FormGroup,
  Input,
  Label,
  PageTitle,
} from 'shared-components';
import Routes from '../../app/routes';
import { useSelectorTemplateDraft } from './use-selector-template-draft';
import { SelectorFormView } from './selector-form-view';
import { SelectorCanvasView } from './canvas/selector-canvas-view';
import styles from './product-selector-editor.module.css';

export const SelectorTemplateEditor = () => {
  const state = useSelectorTemplateDraft();
  const [viewMode, setViewMode] = useState<'form' | 'canvas'>('canvas');

  const { draft, isLoading, id, updateDraft, handleAddNode, handleSave, handleArchive } =
    state;

  if (isLoading || !draft) {
    return <span>loading...</span>;
  }

  return (
    <>
      <PageTitle
        title={draft.name}
        allowSave={!draft.isArchived}
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.PRODUCTS.title, link: Routes.PRODUCTS.link },
          {
            display: Routes.PRODUCT_SELECTORS.title,
            link: Routes.PRODUCT_SELECTORS.link,
          },
          {
            display: draft.name,
            link: Routes.PRODUCT_SELECTOR.createLink?.(id) ?? '',
          },
        ]}
        furtherActions={
          draft.isArchived ? [] : [{ value: 'archive', display: 'Archive' }]
        }
        onAction={async (action) => {
          switch (action) {
            case 'save':
              await handleSave();
              break;
            case 'archive':
              await handleArchive();
              break;
          }
        }}
      />

      <Card>
        <CardContent>
          <div className={styles.templateHeader}>
            <FormGroup className={styles.templateName}>
              <Label htmlFor="templateName">Template Name</Label>
              <Input
                id="templateName"
                value={draft.name}
                onChange={(event) => {
                  const value = event.target.value;
                  updateDraft((current) => ({
                    ...current,
                    name: value,
                  }));
                }}
                disabled={draft.isArchived}
              />
            </FormGroup>
            <div className={styles.viewToggleGroup}>
              <span className={styles.viewToggleLabel}>View</span>
              <div className={styles.viewToggle}>
              <button
                className={`${styles.viewToggleButton} ${viewMode === 'form' ? styles.viewToggleActive : ''}`}
                onClick={() => setViewMode('form')}
              >
                Form
              </button>
              <button
                className={`${styles.viewToggleButton} ${viewMode === 'canvas' ? styles.viewToggleActive : ''}`}
                onClick={() => setViewMode('canvas')}
              >
                Canvas
              </button>
              </div>
            </div>
            {viewMode === 'form' && (
              <Button
                tier={ButtonTier.Secondary}
                onClick={() => handleAddNode()}
                disabled={draft.isArchived}
              >
                Add Question
              </Button>
            )}
          </div>
        </CardContent>
      </Card>

      {viewMode === 'form' ? (
        <SelectorFormView state={state} />
      ) : (
        <SelectorCanvasView state={state} />
      )}
    </>
  );
};
